export interface IPreviousApplicantDetails {
  firstName: string;
  lastName: string;
  fullName: string;
  id: string;
  dateOfBirth: Date;
}

export enum TicketApplicantState {
  ForMyself = 'For Myself',
  OrderingFor = 'Ordering For',
  SomeoneElse = 'Someone Else',
}

export interface TicketApplicant {
  applicant: string;
  details?: IPreviousApplicantDetails;
}
